import React, { useContext, useEffect, useState } from "react";
import { Layout } from "../../Components/Layout";
import { menuContext } from "../../Context/menuContex";
import { ShoppingCartItem } from "../../Components/ShoppingCartItem";
import { CheckCircleIcon, ShoppingCartIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { OthersProductsCart } from "../../Components/OthersProductsCart";

export const ShoppingCart = () => {
  const { product, toShoppin, setToShoppin, adicionalsId, saveToLocalStorage } =
    useContext(menuContext);
  const [totalPrice, setTotalPrice] = useState(0);
  const calculateTotal = () => {
    let total = 0;
    toShoppin?.forEach((product) => {
      total += (product?.price ?? 0) * (product?.quantity ?? 1);
    });
    const formattedTotal = total.toLocaleString(undefined, {
      minimumFractionDigits: 0,
    });

    // Asignar el total formateado al estado totalPrice
    setTotalPrice(formattedTotal);
  };
  useEffect(() => {
    calculateTotal();
  }, [toShoppin]);

  const handdleClick = () => {
    const message = encodeURIComponent(
      `Hola, Me gustaría hacer el siguiente pedido:\n${toShoppin
        .map((item) => `${item.name}: ${item.quantity} x ${item.price}.\n`)
        .join(
          ""
        )}.\nTotal *$${totalPrice}*.\n *Nombre:* \n*Metodo de pago:* \n*Recomendaciones:* \n*Telefono:* \n*Punto de entrega:* `
    );
    window.open(`https://wa.me/+573006395234?text=${message}`, "_blank");
    localStorage.clear();
    setToShoppin([]);
  };
  const handdleClickVaciar = () => {
    setToShoppin([]);
    localStorage.clear();
  };
  return (
    <Layout>
      <h1 className="w-full text-left text-xl font-bold">Tu Compra:</h1>
      <section className="w-[90%] flex flex-col self-center gap-2 pt-2">
        {toShoppin.map((item) => {
          return (
            <ShoppingCartItem
              item={item}
              key={item.adicionalsId ? item.adicionalsId : item.id}
            />
          );
        })}
      </section>
      <button
        className=" p-3 bg-[#000000] text-white text-lg font-semibold rounded-2xl mt-5 mb-16"
        onClick={() => {
          handdleClickVaciar();
        }}
      >
        Vaciar carrito
      </button>
      {toShoppin.length > 0 ? (
        <section className="w-[90%] flex flex-col self-center gap-2 pt-2 mb-11">
          {["Adiciones" /* "Bebidas" */].sort().map((categoryName) => (
            <div key={categoryName} className=" flex flex-col gap-2">
              <h2 className="font-bold text-gray-500">{categoryName}</h2>
              {product
                .filter((item) => item.category_Name === categoryName)
                .map((filteredItem, index) => (
                  <OthersProductsCart
                    item={{
                      ...filteredItem,
                      adicionalsId: adicionalsId[index],
                    }}
                    key={filteredItem.id}
                  />
                ))}
            </div>
          ))}
        </section>
      ) : null}

      <footer className="bg-[#000000] text-white flex justify-end w-full h-10 z-10 fixed bottom-0">
        <div className="flex justify-items-end p-1">
          <p className="font-semibold text-base  self-center mr-4">
            Esta compra: $ {totalPrice}
          </p>
          <Link
            to={"/"}
            className="flex self-center relative cursor-pointer"
            onClick={() => handdleClick()}
          >
            <span
              onClick={(e) => e.stopPropagation()}
              className="absolute w-5 h-5 left-1 inset-0 rounded-full  border-solid  border-2 border-gray-300 border-opacity-55 animate-ripple"
            ></span>

            <ShoppingCartIcon className=" w-7  self-end pb-1 relative left-1 top-1 " />
            <CheckCircleIcon className=" text-green-500 w-4 relative top-[-11px]" />
          </Link>
        </div>
      </footer>
    </Layout>
  );
};
